import React from 'react';
import { motion } from 'framer-motion';
import { Search, Target, Zap, Settings } from 'lucide-react';
export function MethodSection() {
  const steps = [{
    icon: Search,
    title: 'Identificar',
    desc: 'Tus habilidades monetizables ocultas.'
  }, {
    icon: Target,
    title: 'Definir',
    desc: 'Una oferta mínima viable irresistible.'
  }, {
    icon: Zap,
    title: 'Ejecutar',
    desc: 'Lanzamiento rápido en solo 7 días.'
  }, {
    icon: Settings,
    title: 'Ajustar',
    desc: 'Optimizar según los primeros resultados.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-brand-dark text-white relative overflow-hidden" data-id="element-109">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5" data-id="element-110">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-111"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-113">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4" data-id="element-114">
            El Método <span className="text-brand-accent" data-id="element-115">IDEA Rápida</span>
          </h2>
          <p className="text-lg md:text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-116">
            Tu sistema paso a paso para lanzar en 7 días
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-117">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative group" data-id="element-118">
              <div className="bg-slate-800/80 backdrop-blur-md border border-slate-700 p-8 rounded-3xl h-full flex flex-col items-center text-center transition-all duration-300 hover:border-brand-accent/50 hover:shadow-[0_0_30px_rgba(34,197,94,0.15)] hover:-translate-y-1" data-id="element-119">
                <div className="w-16 h-16 bg-brand-darker rounded-2xl flex items-center justify-center mb-6 border border-slate-700 group-hover:border-brand-accent/50 transition-colors" data-id="element-120">
                  <step.icon className="w-8 h-8 text-brand-accent" data-id="element-121" />
                </div>
                <h3 className="font-heading text-2xl font-bold mb-3 text-white" data-id="element-122">
                  {step.title}
                </h3>
                <p className="text-slate-400 font-medium" data-id="element-123">{step.desc}</p>
              </div>

              {/* Connector line for desktop */}
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-4 w-8 border-t-2 border-dashed border-slate-600 z-0" data-id="element-124"></div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}